import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Container from "react-bootstrap/Container";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import "./Rooms.scss";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Room from "../../components/room/Room";

import { useLangContext } from "../../context/languageContext";
import { getRoomCountries, getRoomCitiesByCountry } from "../../api/apiRequest";
import { Tag } from "../../utils/GTMPageTag";

const Rooms = (props) => {
    Tag("Rooms")
    const { country } = useParams();
    const {hostLanguage,languageJson} = useLangContext();
    const [countries,setCountries] = useState([]);
    const [countryTab,setCountryTab] = useState(country !== undefined ? country : undefined);

    const [cities,setCities] = useState([]);

    const handleTabCountry = (tab_type) => {
        setCountryTab(tab_type);
        window.history.replaceState({}, null, props.link+'/'+tab_type);
    }

    //GET countries
    const getCountries = async() => {
        try
        {
            let apiRes = await getRoomCountries();
            let responseData = await apiRes.json();
            if(responseData.res)
            {
                const dataArr = Object.values(responseData.data).flat();
                setCountries(dataArr);
                
                
            } else {
                console.error(responseData.msg);
            }
        }
        catch(error)
        {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    }
    useEffect(()=>{
        getCountries();
    },[hostLanguage])

    //GET cities
    const getCities = async(country) => {
        try
        {
            let apiRes = await getRoomCitiesByCountry(country);
            let responseData = await apiRes.json();
            if(responseData.res)
            {
                const dataArr = Object.values(responseData.data).flat();
                setCities(dataArr);
            } else {
                //
            }
        }
        catch(error)
        {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    }
    useEffect(()=>{
        if(countries.length > 0){
            if(countryTab === undefined){
                setCountryTab(countries[0]?.id)
            }
        }
    },[countries, countryTab])
    
    useEffect(()=>{
        if(countryTab !== undefined){
            setCities([]);
            getCities(countryTab);
        }
    },[countryTab])

    return (
        <div className="MainbBody ConferenceRoom">
            <Container>
                <Tabs 
                    id="countries"
                    defaultActiveKey={countryTab}
                    onSelect={handleTabCountry}
                >
                    {countries?.length > 0 ? (
                        countries?.map((country, index)=>{
                            return(
                                <Tab key={index} eventKey={country?.id} title={country?.name}>
                                    {cities?.length > 0 ? (
                                        cities?.map((city, index)=>{
                                            return(
                                                (city.addresses?.length > 0 ? 
                                                    <Row key={index}>
                                                        <Col sm={12}>
                                                            <div className="ScetionTitel">
                                                                <h2>{city?.name}</h2>
                                                            </div>
                                                        </Col>
                                                        {city.addresses?.map((address, index)=>{
                                                            return (
                                                                <Col key={index} sm={12}>
                                                                    {address?.rooms?.map((room, index)=>{
                                                                        return (
                                                                            <Room key={index} entity={room} address={address} city={city}/>
                                                                        );
                                                                    })}
                                                                </Col>
                                                            );
                                                        })}
                                                    </Row>
                                                : 
                                                    null
                                                )
                                            )
                                        })
                                    ):(
                                        ''
                                    )}
                                </Tab>
                            )
                        })
                    ):(
                        ''
                    )}
                </Tabs>
                {countries?.length <= 0 ? (
                    <div>
                        {languageJson?.no_rooms}
                    </div>
                ):(
                    ''
                )}
            </Container>
        </div>
    );
}
export default Rooms;